import PostsList from './posts-list';
import { queryArgsAsMap, getUrlWithQueryArgs, getUrlQueryArg } from '../../util/url-util';

class PostsListEvent extends PostsList {
    constructor(el) {
        super(el);

        this.setEndpoint('wp/v2/events');
        this.setColumnClasses('small-12 medium-6 large-3');

        this.formSearchEl = this.el.querySelector('form#form_filter_search');
        this.filterLocationEl = this.el.querySelector('select#filter_location');
        this.filterTypeEl = this.el.querySelector('select#filter_type');
        this.filterDateEl = this.el.querySelector('select#filter_date');

        this.filterLocationSlug = getUrlQueryArg('location', '');
        this.filterTypeSlug = getUrlQueryArg('type', '');
        this.filterDate = getUrlQueryArg('date', '');
        this.filterSearch = getUrlQueryArg('search', '');

        this.currentPage = 1; // Initialize the current page

        // Re-add the event listener for the search form
        if (this.formSearchEl) {
            this.formSearchEl.addEventListener('submit', (e) => {
                e.preventDefault();

                const inputEl = e.currentTarget.querySelector('input');
                if (inputEl) {
                    this.filterSearch = inputEl.value.trim();
                    this.resetPosts(); // Call resetPosts to apply the search filter and refresh the posts
                }
            });
        }

        this.loadMoreButton = this.el.querySelector('.js__load-more');
        if (this.loadMoreButton) {
            this.loadMoreButton.addEventListener('click', (e) => {
                e.preventDefault();
                this.loadNextPage();
            });
        }

        if (this.filterLocationEl) {
            this.filterLocationEl.addEventListener('change', (e) => {
                this.filterLocationSlug = e.currentTarget.value ?? '';
                this.resetPosts();
            });
        }

        if (this.filterTypeEl) {
            this.filterTypeEl.addEventListener('change', (e) => {
                this.filterTypeSlug = e.currentTarget.value ?? '';
                this.resetPosts();
            });
        }

        if (this.filterDateEl) {
            this.filterDateEl.addEventListener('change', (e) => {
                this.filterDate = e.currentTarget.value ?? '';
                this.resetPosts();
            });
        }
    }

    loadEventPosts() {
        const params = {
            location: this.filterLocationSlug,
            type: this.filterTypeSlug,
            date: this.filterDate,
            search: this.filterSearch,
            page: this.currentPage, // Use current page
            per_page: this.cardsContainer.getAttribute('data-posts-per-page'),
        };

        this.loadMorePosts(params);
    }

    loadNextPage() {
        this.currentPage++; // Increment the current page
        this.loadEventPosts();
    }

    resetPosts() {
        this.currentPage = 1; // Reset to the first page when filtering
        this.updateURL();
        this.clearCardsContainer();
        this.loadEventPosts();
    }

    updateURL() {
        const args = queryArgsAsMap();

        if (this.filterLocationSlug) {
            args.set('location', this.filterLocationSlug);
        } else {
            args.delete('location');
        }

        if (this.filterTypeSlug) {
            args.set('type', this.filterTypeSlug);
        } else {
            args.delete('type');
        }

        if (this.filterDate) {
            args.set('date', this.filterDate);
        } else {
            args.delete('date');
        }

        if (this.filterSearch) {
            args.set('search', this.filterSearch);
        } else {
            args.delete('search');
        }

        window.history.replaceState({}, '', getUrlWithQueryArgs(args));
    }
}

export default PostsListEvent;
